// next-themes (and ThemedTopNav's class-component mirror of it) persist the live
// theme value to localStorage under this key, AND next-themes attaches a
// window 'storage' listener on this exact key to sync theme across tabs — a
// built-in behavior with no opt-out prop. Because dark mode here is meant to be
// per-dashboard/per-tab (see ColorModeContext.js), that cross-tab sync causes
// toggling dark mode in one tab to leak into every other open tab.
//
// Scoping the key to a per-tab id (via sessionStorage, which is never shared
// between tabs) means no two tabs ever write the same key, so the native
// 'storage' event next-themes listens for never fires across tabs — while
// still persisting correctly across reloads of the SAME tab.
const TAB_ID_KEY = 'goodera-tab-id';
const BASE_STORAGE_KEY = 'goodera-color-mode';

let cachedKey;

export const getColorModeStorageKey = () => {
	if (cachedKey) return cachedKey;
	try {
		let tabId = sessionStorage.getItem(TAB_ID_KEY);
		if (!tabId) {
			tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
			sessionStorage.setItem(TAB_ID_KEY, tabId);
		}
		cachedKey = `${BASE_STORAGE_KEY}-${tabId}`;
	} catch {
		// sessionStorage unavailable (e.g. some test environments) — fall back to
		// the shared key; cross-tab sync bug can reappear there but functionality
		// still works.
		cachedKey = BASE_STORAGE_KEY;
	}
	return cachedKey;
};
